






























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { showError, showSuccess, showWarning } from "@/utils/Common";
import {
  MSG_ADD_SUCCESS,
  MSG_INVALID_PAGE,
  MSG_MODIFY_SUCCESS,
} from "@/configs/Consts";

@Component
export default class BuildingForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  buildingItem!: any;

  isEditBuilding() {
    return this.buildingItem && this.buildingItem.id;
  }

  saveBuilding() {
    const form = this.$refs.buildingForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const buildingData = JSON.parse(JSON.stringify(this.buildingItem));
      this.$store
        .dispatch(
          this.isEditBuilding()
            ? "building/updateBuilding"
            : "building/addBuilding",
          buildingData
        )
        .then(() => {
          this.$emit("update:buildingItem", {});
          showSuccess(
            this.isEditBuilding() ? MSG_MODIFY_SUCCESS : MSG_ADD_SUCCESS
          );
          this.$emit("data-success");
        })
        .catch(({ message }) => showError(message));
    });
  }
}
